var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { CustomFormElementResponseDto } from './custom-form-element.response.dto.js';
import { CustomFormSectionResponseDto } from './custom-form-section.response.dto.js';
/**
 * Response DTO for CustomForm queries.
 * This is independent of the Domain Entity and optimized for the view.
 *
 * @remarks
 * Use this DTO instead of `CustomFormFullSizeDto` or `CustomForm` entity.
 * Those are deprecated in favor of dedicated Response DTOs.
 */
export class CustomFormResponseDto {
    id;
    createdAt;
    updatedAt;
    title;
    description;
    isDefaultForm;
    visibleForPatients;
    officeId;
    /**
     * Flat view of all elements (backward-compatible read path). Prefer
     * `customFormSections` for section-aware consumers.
     *
     * This is the compatibility path for old, cached PWA clients that predate
     * the section rework and only understand this flat list — do not remove
     * it, even once no code in this repo reads it anymore.
     */
    customFormElements;
    customFormSections;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], CustomFormResponseDto.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Date)
], CustomFormResponseDto.prototype, "createdAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Date)
], CustomFormResponseDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], CustomFormResponseDto.prototype, "title", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], CustomFormResponseDto.prototype, "description", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], CustomFormResponseDto.prototype, "isDefaultForm", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], CustomFormResponseDto.prototype, "visibleForPatients", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], CustomFormResponseDto.prototype, "officeId", void 0);
__decorate([
    Expose(),
    Type(() => CustomFormElementResponseDto),
    __metadata("design:type", Array)
], CustomFormResponseDto.prototype, "customFormElements", void 0);
__decorate([
    Expose(),
    Type(() => CustomFormSectionResponseDto),
    __metadata("design:type", Array)
], CustomFormResponseDto.prototype, "customFormSections", void 0);
//# sourceMappingURL=custom-form.response.dto.js.map